import React from 'react';

import { CheckCircleIcon } from '@vlabs/icons';
import { Margin } from '@vlabs/uikit';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import st from './CreateHandlerForm.module.sass';

interface CreatedHandlerFormProps {
  handlerId?: string;
  handlerName?: string;
}

function CreatedHandlerForm({
  handlerId = undefined,
  handlerName = undefined,
}: CreatedHandlerFormProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Margin display="block">
        <div className={st.HeaderContainer}>
          <CheckCircleIcon className={st.Icon} />
          <h5>
            {t('handlers:создание.успех.заголовок', { description: handlerName })}
          </h5>
        </div>
      </Margin>

      <Margin display="block">
        <div className="Body-2">
          <p>
            <Trans
              i18nKey="handlers:создание.успех.текст"
              values={{ handlerId }}
            />
          </p>
          <p>
            <Trans
              components={{
                a: <Link
                  data-testid="linkToHandler"
                  to={`/handlers/${handlerId}`}
                />,
              }}
              i18nKey="handlers:создание.успех.описание сценария"
            />
          </p>
        </div>
      </Margin>
    </React.Fragment>
  );
}

export { CreatedHandlerForm };
